import { createRouter, createWebHistory } from "vue-router";
import { fetchAuthSession } from "aws-amplify/auth";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "app",
      component: () => import("@/App.vue"),
    },
    {
      path: "/view",
      name: "view",
      component: () => import("@/App.vue"),
      meta: { readOnly: true },
    },
    {
      path: "/read",
      name: "read",
      component: () => import("@/App.vue"),
      meta: { requiresAuth: false, readOnly: true, public: true },
      beforeEnter: async (to, _from, next) => {
        try {
          const session = await fetchAuthSession();
          if (session.tokens?.idToken) {
            next({ path: "/", query: to.query });
          } else {
            next();
          }
        } catch {
          next();
        }
      },
    },
    {
      path: "/api-docs",
      name: "api-docs",
      component: () => import("@/views/ApiDocs.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/cases",
      name: "cases",
      component: () => import("@/views/CaseList.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/admin",
      name: "admin",
      component: () => import("@/views/AdminPage.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/views/ErrorPage.vue"),
      meta: { requiresAuth: false },
    },
    {
      path: "/:pathMatch(.*)*",
      name: "catch-all",
      redirect: (to) => {
        const query = to.query;
        return { path: "/", query };
      },
    },
  ],
});

const AUTH_REDIRECT_KEY = "authRedirect";

router.beforeEach(async (to, _from, next) => {
  if (to.meta.requiresAuth) {
    try {
      const session = await fetchAuthSession();
      if (session.tokens?.idToken) {
        next();
      } else {
        sessionStorage.setItem(AUTH_REDIRECT_KEY, to.fullPath);
        next({ path: "/" });
      }
    } catch {
      sessionStorage.setItem(AUTH_REDIRECT_KEY, to.fullPath);
      next({ path: "/" });
    }
  } else if (to.path === "/") {
    try {
      const session = await fetchAuthSession();
      if (session.tokens?.idToken) {
        const storedRedirect = sessionStorage.getItem(AUTH_REDIRECT_KEY);
        if (storedRedirect) {
          sessionStorage.removeItem(AUTH_REDIRECT_KEY);
          next({ path: storedRedirect, replace: true });
        } else if (to.query.redirect) {
          const redirectPath = to.query.redirect as string;
          next({ path: redirectPath, replace: true });
        } else {
          next();
        }
      } else {
        next();
      }
    } catch {
      next();
    }
  } else {
    next();
  }
});

export default router;
